exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlight[data-v-5814c9b6] div{display:inline}.yacht-activity[data-v-5814c9b6]{display:flex;margin-bottom:64px}.yacht-activity__thumb[data-v-5814c9b6]{margin-bottom:0;margin-right:32px}.enquire-button[data-v-5814c9b6]{min-width:6.75rem}@media(max-width:600px){.itinerary-detail-button[data-v-5814c9b6]{height:48px;width:100%}.yacht-activity[data-v-5814c9b6]{flex-direction:column}.yacht-activity__thumb[data-v-5814c9b6]{margin-bottom:32px;margin-right:0}.yacht-activity[data-v-5814c9b6]:nth-child(2n){flex-direction:column}}", ""]);

// exports
